export enum PropertyFloorPlanTypes {
  Web,
  Print,
}
